import { notifyRequestError } from "@impero-com/common/utils/query_client";
import { useQueryClient } from "@tanstack/react-query";

import { getPostControlsNewQueryKey } from "api/generated/controls/controls";
import {
    getGetOrganizationSettingsQueryKey,
    usePatchOrganizationSettings,
} from "api/generated/organization-settings/organization-settings";
import { getGetUserEventsLatestQueryKey } from "api/generated/utils/utils";

import { CONTROL_QUERY_KEY } from "../../control/queries/useControlQuery";
import { isSegregationOfDutiesRefusal } from "../segregationOfDutiesRefusal";

export function useUpdateControlPoliciesMutation() {
    const client = useQueryClient();

    return usePatchOrganizationSettings({
        mutation: {
            onSuccess: () => {
                // Control forms take their defaults from the cache once, so invalidating is not enough.
                client.removeQueries({ queryKey: [CONTROL_QUERY_KEY] });
                client.removeQueries({
                    queryKey: getPostControlsNewQueryKey(),
                });
                void client.invalidateQueries({
                    queryKey: getGetUserEventsLatestQueryKey(),
                });
                return client.invalidateQueries({
                    queryKey: getGetOrganizationSettingsQueryKey(),
                });
            },
            onError: (error) => {
                if (!isSegregationOfDutiesRefusal(error)) {
                    notifyRequestError(error);
                }
            },
        },
    });
}
